import { useState, useCallback, useEffect } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { BaseSection } from 'components/layouts';
import { BaseContainer } from 'components/containers';
import { BranchSearch, AddressLinkedBranchModal, FillButton, BaseDatePicker } from 'components/elements';
import { Row, Col, Divider, Descriptions, Input, Select, Space, Flex, Checkbox, DatePicker, Radio } from 'antd';
import { getJoinCounselAPI,putJoinAppCounselAPI } from 'api/join-counsel';
import { ageOptions, joinCognitivePathOptions, phoneOptions, personalInfoAgreeOptions } from 'data/options';
import { fnCombinePhone, fnSeparatePhone, formatNum, objToLowerCase } from 'utils/utils';
import { useAuth } from 'hooks/AuthContext';
import { fnGetToday } from 'utils/utils';
import dayjs from "dayjs";


const NonMemberJoinCounselAdd = () => {
  const { user, logout } = useAuth();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const idx = Number(searchParams.get('idx'));
  const [data, setData] = useState({
    cell_phone: {first: '010'},
    personal_info_agree: 1,
    disabled:false,
  })


  const fnGetDetail = async () => {
    try {
      const { data } = await getJoinCounselAPI(idx);
      const { data_info } = data;
      setData({
        ...objToLowerCase(data_info), 
        cell_phone: fnSeparatePhone(data_info?.CELL_PHONE),
        disabled: data_info.PROGRESS_STATUS === '5' ?  true : false,
      })

    } catch (err) {
      console.error(err)
    }
  }


  const fnHandleData = useCallback((value) => {
    setData(data => ({
      ...data,
      ...value
    }))
  }, []);

  useEffect(() => {
    logout();
    fnGetDetail();
  }, []);

  useEffect(() => {
    console.log(data)
  }, [data]);

  const fnAddJoinCounsel = async () => {
    if(!data?.member_name){
      alert('자녀명을 입력해주세요.');
      return false;
    }
    if(!data?.parent_name){
      alert('보호자명을 입력해주세요.');
      return false;
    }
    if(!data?.cell_phone?.middle || !data?.cell_phone?.last){
      alert('휴대폰번호를 입력해주세요.');
      return false;
    }
    if(!data?.birth){
      alert('자녀생년월일을 선택해주세요.');
      return false;
    }
    if(!data?.cognitive_path?.length > 0) {
      alert('인지경로를 선택해주세요.');
      return false;
    }
    if(!data?.hope_area){
      alert('주소를 입력해주세요.');
      return false;
    }

    const sendData = {
      ...data,
      birth : data.birthString,
      cell_phone: fnCombinePhone(data?.cell_phone)
    }

    await putJoinAppCounselAPI(sendData)
    .then(res => {
      const { responseCode } = res.data;
      if(responseCode === 200) {
        alert('등록이 완료되었습니다.');
        setData({
          ...data,
          disabled : true,
          progress_status: 5,
          cell_phone: {first: '010'}
        })
      }
    }).catch(err => {
      console.error(err);
    })
  }

  const items1 = [
    {
      key: '0',
      label: <span className="text-require">자녀명</span>,
      children: (
        <Input 
          placeholder='자녀명' 
          value={data?.member_name} 
          onChange={e => setData({...data, member_name:e.target.value})} 
          disabled={data?.disabled}
        />
      )
    },
  {
    key: '1',
    label: <span className="text-require">보호자명</span>,
    children: (
      <Input 
        placeholder='보호자명' 
        value={data?.parent_name} 
        onChange={e => setData({...data, parent_name:e.target.value})} 
        disabled={data?.disabled}
      />
    )
  },
  {
    key: '2',
    label: <span className="text-require">보호자휴대폰번호</span>,
    children: 
      <Space>
        <Select 
          options={phoneOptions} 
          onSelect={(v) => fnHandleData({cell_phone: {...data?.cell_phone, first: formatNum(v)}})}
          value={data?.cell_phone?.first}
          disabled={data?.disabled}
        />       
        <Input 
          value={data?.cell_phone?.middle} 
          maxLength={4}
          onChange={(e) => fnHandleData({cell_phone: {...data?.cell_phone, middle: formatNum(e.target.value)}})}
          disabled={data?.disabled}
        />
        -
        <Input 
          value={data?.cell_phone?.last} 
          maxLength={4}
          onChange={(e) => fnHandleData({cell_phone: {...data?.cell_phone, last: formatNum(e.target.value)}})}
          disabled={data?.disabled}
        />
      </Space>
  },   
  {
    key: '3',
    label: <span className="text-require">자녀생년월일</span>,
    children: (
    <>
      <DatePicker 
        value={data?.birth}
        onChange={(date, dateString) => {
          const diffDate = new Date().getFullYear() -  Number(dateString.substring(0,4)) +1;
          if(diffDate >= 10 && diffDate <=13 ) {
            fnHandleData({birth : date, birthString: dateString});
          } else {
            fnHandleData({birth : ''});
            alert('10 ~ 13세의 아동만 신청할 수 있습니다.');
          }
        }}
        disabled={data?.disabled}
      />
    </>
    )
  },      
  {
    key: '4',
    label: <span className="text-require">인지경로</span>,
    children: (
      <Checkbox.Group
        options={joinCognitivePathOptions} 
        value={data?.cognitive_path} 
        onChange={(e) => fnHandleData({ cognitive_path: e })} 
        disabled={data?.disabled}
      />
    )
  },
  {
    key: '5',
    label: <span className="text-require">주소</span>,
    children: 
      <Flex vertical gap={'3px'}>
        <Space>      
          <Input disabled value={data?.hope_area_zip_code} />
          <AddressLinkedBranchModal data={data}  setData={setData}/>
          <BranchSearch hide={true} onSelect={(v) =>fnHandleData({linked_branch_idx: v?.value})} branchIdx={data?.linked_branch_idx} />
        </Space>
        <Input disabled value={data?.hope_area} width={'100%'} />
      </Flex>
  },
  {
    key: '6',
    label: '상세주소',
    children: 
      <Input 
        placeholder='상세주소' 
        value={data?.addr_detail} 
        onChange={(e) => fnHandleData({addr_detail: e.target.value })}
        disabled={data?.disabled} 
      />  
  },
  {
    key: '7',
    label: '개인정보 수집 및 활용 동의',
    children: 
      <Radio.Group value={data?.personal_info_agree} options={personalInfoAgreeOptions} onChange={(e) => fnHandleData({ personal_info_agree: e.target.value })} disabled={data?.disabled} />
  },
];

return (<>
  <BaseSection>
    <BaseContainer>
      <Row>
        <Col span={24}>
          <Descriptions 
            bordered column={1} 
            labelStyle={{ width: '16rem' }} 
            contentStyle={{ textAlign: 'left', width: '100%' }}
            items={items1} 
          />         
        </Col>
      </Row>
      <Divider className='divider'/>   
      <Flex justify='flex-end'>
        <Space>
          {data?.progress_status!=='5' &&
          <FillButton
            label='작성완료' 
            backgroundColor='var(--color-gray03)' 
            onClick={fnAddJoinCounsel}
            disabled={data?.disabled} 
          />}
        </Space>
      </Flex>      
    </BaseContainer>
    </BaseSection>
  </>
  )
}

export default NonMemberJoinCounselAdd;
